function mmSlideAnnouncementBar() {
	var splideElem = document.querySelector(".splide-announcement-bar");
	// SLIDER PRODUCT
	if (splideElem) {
		new Splide(splideElem, {
			type: "loop",
			arrows: false,
			pagination: false,
			autoplay: true,
			perPage: 1,
		}).mount();
	}
}

document.addEventListener("DOMContentLoaded", () => {
	mmSlideAnnouncementBar();
});


const redirectHeaderClassName = document.querySelectorAll(".mm-ab-redirection-selector");
redirectHeaderClassName.forEach((element) => {
	const redirectBodyClassName = element.querySelector(".mm-ab-redirection-container");
	const filterRedirectClassName = element.querySelector(".mm-ab-redirection-filter-close");

	element.addEventListener("click", (event) => {
		redirectBodyClassName.classList.toggle("active");
		filterRedirectClassName.classList.toggle("active");
	});
});
